import { PromoCarousel } from "widgets/defenitions/ynet1280/newYnetTvVerticalDynamic/components/promoCarousel"
import { PromoCarouselLtr } from "widgets/defenitions/newYnetLTRTvVerticalDynamic/components/promoCarouselLtr"
import { MultiImagesMainAutoCarouselItem } from "./multiImagesMainAutoCarouselItem"
import { MultiImagesMainAutoArticleItem, MultiImagesMainAutoFieldsProps, CAROUSEL_ITEM_GAP } from "./multiImagesMainAutoTypes"

interface MultiImagesMainAutoCarouselProps extends MultiImagesMainAutoFieldsProps {
    itemList: MultiImagesMainAutoArticleItem[]
    width: number
    imageWidth: number
    imageHeight: number
    isLTR?: boolean
}

export const MultiImagesMainAutoCarousel = (props: MultiImagesMainAutoCarouselProps) => {
    const { itemList, imageWidth, fieldsDisplaySettings, titleColor, subTitleColor, labelColor, labelBackgroundColor, isLTR } = props
    const PromoCarouselComponent = isLTR ? PromoCarouselLtr : PromoCarousel

    return (
        <div className="carouselSection">
            <PromoCarouselComponent
                imageWidth={imageWidth}
                pushGA4Event={() => undefined}
                marginRight={CAROUSEL_ITEM_GAP}
                itemListLength={itemList ? itemList.length : 0}
            >
                {(itemList || []).map((item, index) => (
                    <MultiImagesMainAutoCarouselItem
                        item={item}
                        index={index}
                        titleColor={titleColor}
                        labelColor={labelColor}
                        subTitleColor={subTitleColor}
                        key={`${item.itemId}_${index}`}
                        itemsMargin={CAROUSEL_ITEM_GAP}
                        labelBackgroundColor={labelBackgroundColor}
                        fieldsDisplaySettings={fieldsDisplaySettings}
                    />
                ))}
            </PromoCarouselComponent>
        </div>
    )
}

MultiImagesMainAutoCarousel.siteScriptName = "MultiImagesMainAutoCarousel"
